import dayjs from 'dayjs';

export interface ICorrectionFactor {
  id?: number;
  correctionFactor?: number | null;
  effectiveDate?: dayjs.Dayjs | null;
  expirationDate?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<ICorrectionFactor> = {};
